'use client';

import { useEffect, useState } from 'react';

import { useSearchParams } from 'next/navigation';
import { useRouter } from '@shared/hooks/use-router';
import AppLoader from '@/components/ui/app-loader';

import { APP_ROUTES } from '../constants/navigation';
import { QUERY_PARAMS } from '../constants/query-params';

export default function NavigateAutomatically({ delay = 0 }: { delay?: number }) {
	const [showContent, setShowContent] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => {
			setShowContent(true);
		}, delay);

		return () => clearTimeout(timer);
	}, [delay]);

	return showContent ? (
		<NavigateAutomaticallyMain />
	) : (
		<main className="flex h-screen w-screen items-center justify-center overflow-hidden">
			<AppLoader />
		</main>
	);
}

function NavigateAutomaticallyMain() {
	const redirectPath = useSearchParams().get(QUERY_PARAMS.REDIRECT_PATH) || APP_ROUTES.ROOT;
	const router = useRouter();

	useEffect(() => {
		if (redirectPath) router.replace(redirectPath);
	}, [redirectPath]);

	return null;
}
